(function () {
  function initializePartBCalculator() {
    var calculator = document.querySelector(".na-part-b-calculator");

    if (!calculator || calculator.getAttribute("data-initialized") === "true") {
      return;
    }

    calculator.setAttribute("data-initialized", "true");

    var PPM_PER_DKH = 17.848;
    var MAX_DAILY_CORRECTION_DKH = 1.4;

    function getNumber(id) {
      var field = document.getElementById(id);
      return field ? parseFloat(field.value) : NaN;
    }

    function trimNumber(value, decimals) {
      return Number(value)
        .toFixed(decimals)
        .replace(/0+$/, "")
        .replace(/\.$/, "");
    }

    function formatDose(value) {
      if (!Number.isFinite(value)) {
        return "—";
      }

      if (value < 10) {
        return trimNumber(value, 2) + " mL";
      }

      return trimNumber(value, 1) + " mL";
    }

    function ppmToDkh(ppm) {
      return ppm / PPM_PER_DKH;
    }

    function dkhToPpm(dkh) {
      return dkh * PPM_PER_DKH;
    }

    function valueToDkh(value, unit) {
      return unit === "ppm" ? ppmToDkh(value) : value;
    }

    function showMessage(element, type, message) {
      if (!element) return;

      element.className = "na-b-message show " + type;
      element.innerHTML = message;
    }

    function clearMessage(element) {
      if (!element) return;

      element.className = "na-b-message";
      element.innerHTML = "";
    }

    /* Tabs */
    var tabs = calculator.querySelectorAll(".na-b-tab");
    var panels = calculator.querySelectorAll(".na-b-panel");

    tabs.forEach(function (button) {
      button.addEventListener("click", function () {
        var targetId = button.getAttribute("data-target");
        var targetPanel = document.getElementById(targetId);

        tabs.forEach(function (tab) {
          tab.classList.remove("active");
          tab.setAttribute("aria-selected", "false");
        });

        panels.forEach(function (panel) {
          panel.classList.remove("active");
        });

        button.classList.add("active");
        button.setAttribute("aria-selected", "true");

        if (targetPanel) {
          targetPanel.classList.add("active");
        }
      });
    });

    /* Correction unit selector */
    var correctionUnitField = document.getElementById(
      "na-b-correction-unit"
    );

    if (correctionUnitField) {
      correctionUnitField.addEventListener("change", function () {
        var unit = correctionUnitField.value;

        var currentInput = document.getElementById(
          "na-b-current-alk"
        );

        var targetInput = document.getElementById(
          "na-b-target-alk"
        );

        var currentUnitLabel = document.getElementById(
          "na-b-current-unit-label"
        );

        var targetUnitLabel = document.getElementById(
          "na-b-target-unit-label"
        );

        var rangeNote = document.getElementById(
          "na-b-target-range-note"
        );

        if (unit === "ppm") {
          currentUnitLabel.textContent = "ppm";
          targetUnitLabel.textContent = "ppm";

          currentInput.step = "1";
          targetInput.step = "1";

          currentInput.placeholder = "Example: 125";
          targetInput.value = "143";

          rangeNote.innerHTML =
            "Perfect Corals suggests approximately 125–143 ppm, " +
            "with approximately 143–161 ppm as the upper threshold.";
        } else {
          currentUnitLabel.textContent = "dKH";
          targetUnitLabel.textContent = "dKH";

          currentInput.step = "0.1";
          targetInput.step = "0.1";

          currentInput.placeholder = "Example: 7.0";
          targetInput.value = "8.0";

          rangeNote.innerHTML =
            "Perfect Corals suggests 7–8 dKH, with 8–9 dKH " +
            "as the upper threshold.";
        }
      });
    }

    /* Maintenance unit selector */
    var maintenanceUnitField = document.getElementById(
      "na-b-maintenance-unit"
    );

    if (maintenanceUnitField) {
      maintenanceUnitField.addEventListener("change", function () {
        var unit = maintenanceUnitField.value;

        var dropInput = document.getElementById(
          "na-b-alk-drop"
        );

        var dropUnitLabel = document.getElementById(
          "na-b-drop-unit-label"
        );

        if (unit === "ppm") {
          dropUnitLabel.textContent = "ppm";
          dropInput.step = "0.1";
          dropInput.placeholder = "Example: 3.6";
        } else {
          dropUnitLabel.textContent = "dKH";
          dropInput.step = "0.01";
          dropInput.placeholder = "Example: 0.2";
        }
      });
    }

    /* Correction calculator */
    var correctionButton = document.getElementById(
      "na-b-calculate-correction"
    );

    if (correctionButton) {
      correctionButton.addEventListener("click", function () {
        var volume = getNumber("na-b-water-volume");
        var currentEntered = getNumber("na-b-current-alk");
        var targetEntered = getNumber("na-b-target-alk");

        var unitField = document.getElementById(
          "na-b-correction-unit"
        );

        var selectedUnit = unitField ? unitField.value : "dkh";

        var message = document.getElementById(
          "na-b-correction-message"
        );

        var results = document.getElementById(
          "na-b-correction-results"
        );

        clearMessage(message);

        if (results) {
          results.hidden = true;
        }

        if (
          !Number.isFinite(volume) ||
          !Number.isFinite(currentEntered) ||
          !Number.isFinite(targetEntered)
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please complete all three fields.</strong>"
          );
          return;
        }

        if (
          volume <= 0 ||
          currentEntered <= 0 ||
          targetEntered <= 0
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please enter numbers greater than zero.</strong>"
          );
          return;
        }

        var currentDkh = valueToDkh(
          currentEntered,
          selectedUnit
        );

        var targetDkh = valueToDkh(
          targetEntered,
          selectedUnit
        );

        if (currentDkh >= targetDkh) {
          showMessage(
            message,
            "warning",
            "<strong>No alkalinity correction is indicated.</strong> " +
            "Current alkalinity is already equal to or higher than " +
            "the selected target."
          );
          return;
        }

        var increaseDkh = targetDkh - currentDkh;
        var increasePpm = dkhToPpm(increaseDkh);

        /*
          Perfect Corals Part B formula:
          dKH increase × gallons × 0.72 = mL
        */
        var totalDose = increaseDkh * volume * 0.72;

        /*
          General reef-safety correction limit:
          1.4 dKH per 24 hours.
        */
        var maximumDailyDose =
          MAX_DAILY_CORRECTION_DKH * volume * 0.72;

        var correctionDays = Math.ceil(
          increaseDkh / MAX_DAILY_CORRECTION_DKH
        );

        var fullDays = Math.floor(
          increaseDkh / MAX_DAILY_CORRECTION_DKH
        );

        var finalIncreaseDkh =
          increaseDkh -
          fullDays * MAX_DAILY_CORRECTION_DKH;

        var finalDose =
          finalIncreaseDkh * volume * 0.72;

        document.getElementById(
          "na-b-total-dose"
        ).textContent = formatDose(totalDose);

        document.getElementById(
          "na-b-dkh-increase"
        ).textContent =
          trimNumber(increaseDkh, 2) + " dKH";

        document.getElementById(
          "na-b-ppm-increase"
        ).textContent =
          trimNumber(increasePpm, 1) +
          " ppm as CaCO₃";

        document.getElementById(
          "na-b-max-daily-increase"
        ).textContent =
          "1.4 dKH / " +
          trimNumber(dkhToPpm(1.4), 1) +
          " ppm";

        document.getElementById(
          "na-b-max-daily-dose"
        ).textContent =
          formatDose(maximumDailyDose) +
          " per day";

        document.getElementById(
          "na-b-correction-days"
        ).textContent =
          correctionDays === 1
            ? "At least 1 day"
            : "At least " + correctionDays + " days";

        var plan =
          "<strong>Correction plan</strong><p>";

        plan +=
          "The total estimated correction is " +
          formatDose(totalDose) +
          ", representing an increase of " +
          trimNumber(increaseDkh, 2) +
          " dKH (" +
          trimNumber(increasePpm, 1) +
          " ppm as CaCO₃). ";

        if (increaseDkh <= MAX_DAILY_CORRECTION_DKH) {
          plan +=
            "This correction is within the general maximum of " +
            "1.4 dKH per 24 hours. Add slowly in a high-flow area, " +
            "allow the product to circulate, and retest.";
        } else {
          plan +=
            "Do not add the full correction at once. Divide it over at " +
            "least " +
            correctionDays +
            " days, raising alkalinity by no more than 1.4 dKH " +
            "or approximately 25 ppm per 24 hours. ";

          if (finalIncreaseDkh > 0.001) {
            plan +=
              "The estimate equals " +
              fullDays +
              (fullDays === 1
                ? " day"
                : " days") +
              " at no more than " +
              formatDose(maximumDailyDose) +
              ", followed by approximately " +
              formatDose(finalDose) +
              " on the final day.";
          }
        }

        plan +=
          "</p><p><strong>Retest alkalinity between correction doses.</strong> " +
          "The 1.4 dKH daily limit is a general reef-safety guideline and " +
          "is not stated on the Perfect Corals Part B label.</p>";

        document.getElementById(
          "na-b-formula-result"
        ).innerHTML = plan;

        if (results) {
          results.hidden = false;
        }

        if (increaseDkh > MAX_DAILY_CORRECTION_DKH) {
          showMessage(
            message,
            "warning",
            "<strong>Large correction detected.</strong> The requested " +
            "increase exceeds 1.4 dKH, or approximately 25 ppm. " +
            "Divide the correction over multiple days and retest between doses."
          );
        } else if (targetDkh > 9) {
          showMessage(
            message,
            "warning",
            "<strong>Your target is above the manufacturer’s stated " +
            "upper threshold of 8–9 dKH.</strong> Confirm the target " +
            "before dosing."
          );
        } else if (targetDkh > 8) {
          showMessage(
            message,
            "warning",
            "<strong>Your target is within the manufacturer’s stated " +
            "upper-threshold range.</strong> Make gradual adjustments."
          );
        } else if (targetDkh < 7) {
          showMessage(
            message,
            "warning",
            "<strong>Your target is below the manufacturer’s suggested " +
            "7–8 dKH range.</strong>"
          );
        } else {
          showMessage(
            message,
            "success",
            "<strong>Calculation complete.</strong> Verify the adjustment " +
            "through testing."
          );
        }
      });
    }

    /* Maintenance calculator */
    var maintenanceButton = document.getElementById(
      "na-b-calculate-maintenance"
    );

    if (maintenanceButton) {
      maintenanceButton.addEventListener("click", function () {
        var volume = getNumber(
          "na-b-maintenance-volume"
        );

        var measuredDropEntered = getNumber(
          "na-b-alk-drop"
        );

        var unitField = document.getElementById(
          "na-b-maintenance-unit"
        );

        var selectedUnit = unitField
          ? unitField.value
          : "dkh";

        var periodField = document.getElementById(
          "na-b-test-period"
        );

        var period = periodField
          ? periodField.value
          : "daily";

        var message = document.getElementById(
          "na-b-maintenance-message"
        );

        var results = document.getElementById(
          "na-b-maintenance-results"
        );

        clearMessage(message);

        if (results) {
          results.hidden = true;
        }

        if (
          !Number.isFinite(volume) ||
          !Number.isFinite(measuredDropEntered)
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please complete all fields.</strong>"
          );
          return;
        }

        if (volume <= 0 || measuredDropEntered < 0) {
          showMessage(
            message,
            "error",
            "<strong>Please enter a valid volume and alkalinity decrease.</strong>"
          );
          return;
        }

        if (measuredDropEntered === 0) {
          showMessage(
            message,
            "warning",
            "<strong>No measurable alkalinity consumption was entered.</strong>"
          );
          return;
        }

        var measuredDropDkh = valueToDkh(
          measuredDropEntered,
          selectedUnit
        );

        var dailyDropDkh;
        var weeklyDropDkh;

        if (period === "weekly") {
          weeklyDropDkh = measuredDropDkh;
          dailyDropDkh = measuredDropDkh / 7;
        } else {
          dailyDropDkh = measuredDropDkh;
          weeklyDropDkh = measuredDropDkh * 7;
        }

        var dailyDose =
          dailyDropDkh * volume * 0.72;

        var weeklyDose =
          weeklyDropDkh * volume * 0.72;

        var fourDose = dailyDose / 4;
        var hourlyDose = dailyDose / 24;

        document.getElementById(
          "na-b-daily-dose"
        ).textContent =
          formatDose(dailyDose) + " per day";

        document.getElementById(
          "na-b-weekly-dose"
        ).textContent =
          formatDose(weeklyDose) + " per week";

        document.getElementById(
          "na-b-four-dose"
        ).textContent =
          formatDose(fourDose) + " per dose";

        document.getElementById(
          "na-b-hourly-dose"
        ).textContent =
          formatDose(hourlyDose) + " per dose";

        document.getElementById(
          "na-b-maintenance-formula"
        ).innerHTML =
          "<strong>Maintenance calculation</strong><p>" +
          "The estimated daily consumption is " +
          trimNumber(dailyDropDkh, 3) +
          " dKH, equivalent to approximately " +
          trimNumber(dkhToPpm(dailyDropDkh), 1) +
          " ppm as CaCO₃. " +
          trimNumber(dailyDropDkh, 3) +
          " × " +
          volume +
          " gallons × 0.72 = " +
          formatDose(dailyDose) +
          " per day.</p><p>The 1.4 dKH daily correction warning " +
          "applies to raising alkalinity above its current level. A mature " +
          "reef may consume more than this daily, in which case its measured " +
          "maintenance consumption still needs to be replaced gradually " +
          "throughout the day.</p>";

        if (results) {
          results.hidden = false;
        }

        showMessage(
          message,
          "success",
          "<strong>Maintenance estimate calculated.</strong> Use this as " +
          "a starting amount and adjust according to repeated testing."
        );
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializePartBCalculator
    );
  } else {
    initializePartBCalculator();
  }

  setTimeout(initializePartBCalculator, 500);
  setTimeout(initializePartBCalculator, 1500);
})();
